import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import ServiceGuidance from "components/ServiceGuidance";
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";

import bgFront1 from "assets/images/servicii/bgFront1.webp";
import bgBack1 from "assets/images/servicii/bgBack1.webp";

const advantages = {
    paragraphs: [
        "Doral Cleaning oferă servicii profesionale de curățenie, respectând termenele stabilite și aplicând procese clare și eficiente de lucru. În proiectele bine organizate, beneficiarii apelează frecvent la serviciile noastre în 2–3 etape distincte.",
        "În proiectele complexe în care etapele anterioare nu au fost realizate, serviciul devine o curățenie generală finală cu detalii postconstructor. Spațiile mobilate sau suprafețele neîngrijite necesită timp suplimentar, costuri adiționale și atenție sporită la protejarea bunurilor.",
    ],
    items: [
        { title: "Curățenie grosieră", text: "Realizată pe durata lucrărilor, pentru degajarea și menținerea spațiilor, disciplina de șantier și prevenirea accidentelor." },
        { title: "Spălarea pardoselilor flotante / curățarea sub flotantă", text: "Efectuată înainte de finisajele finale, mochetare sau montarea altor învelitori." },
        { title: "Curățenie postconstructor", text: "Realizată înainte de mobilier și decor, incluzând tavane, fațade, suprafețe vitrate, uși și grupuri sanitare." },
    ],
};

const advice = {
    paragraphs: [
        "Alegeți o firmă specializată care verifică și testează suprafețele înainte de intervenție, ținând cont de natura materialelor și de produsele utilizate. Curățarea fără echipamente și soluții profesionale poate deteriora finisajele.",
        "Pentru a preveni daunele și a reduce costurile de curățare, protejați pardoselile cu folie groasă și suport textil.",
    ],
};

function InformationHome() {
    return (
        <MKBox component="section" py={6} my={6}>
            <Container>
                <Grid container spacing={4} alignItems="stretch">
                    <Grid item xs={12} lg={4}>
                        <RotatingCard>
                            <RotatingCardFront image={bgFront1} icon="touch_app" title="Curățenie Post-Construct" description="Profesioniști dedicați și soluții adaptate fiecărei suprafețe." />
                            <RotatingCardBack image={bgBack1} title="Garanția calității" description="Solicită o evaluare gratuită." action={{ type: "internal", route: "/contact-curatenie", label: "cere o ofertă" }} />
                        </RotatingCard>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                        <ServiceGuidance advantages={advantages} advice={advice} />
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
